
    import './styles.scoped.css';
    export default {
  "column-layout": "awsui_column-layout_vj6p7_xlofq_97",
  "grid": "awsui_grid_vj6p7_xlofq_132",
  "grid-no-gutters": "awsui_grid-no-gutters_vj6p7_xlofq_138",
  "grid-variant-text-grid": "awsui_grid-variant-text-grid_vj6p7_xlofq_142",
  "grid-breakpoint-default": "awsui_grid-breakpoint-default_vj6p7_xlofq_150",
  "grid-columns-1": "awsui_grid-columns-1_vj6p7_xlofq_153",
  "grid-breakpoint-xxs": "awsui_grid-breakpoint-xxs_vj6p7_xlofq_153",
  "grid-breakpoint-xs": "awsui_grid-breakpoint-xs_vj6p7_xlofq_156",
  "grid-columns-2": "awsui_grid-columns-2_vj6p7_xlofq_159",
  "grid-columns-3": "awsui_grid-columns-3_vj6p7_xlofq_165",
  "grid-columns-4": "awsui_grid-columns-4_vj6p7_xlofq_171",
  "grid-vertical-borders": "awsui_grid-vertical-borders_vj6p7_xlofq_187",
  "grid-horizontal-borders": "awsui_grid-horizontal-borders_vj6p7_xlofq_220",
  "root": "awsui_root_vj6p7_xlofq_274",
  "tile-container": "awsui_tile-container_vj6p7_xlofq_312",
  "refresh": "awsui_refresh_vj6p7_xlofq_327",
  "has-metadata": "awsui_has-metadata_vj6p7_xlofq_331",
  "selected": "awsui_selected_vj6p7_xlofq_337",
  "disabled": "awsui_disabled_vj6p7_xlofq_342",
  "columns": "awsui_columns_vj6p7_xlofq_358",
  "column-1": "awsui_column-1_vj6p7_xlofq_364",
  "breakpoint-xs": "awsui_breakpoint-xs_vj6p7_xlofq_371",
  "breakpoint-xxs": "awsui_breakpoint-xxs_vj6p7_xlofq_375",
  "column-2": "awsui_column-2_vj6p7_xlofq_379",
  "column-3": "awsui_column-3_vj6p7_xlofq_394",
  "column-4": "awsui_column-4_vj6p7_xlofq_409",
  "control": "awsui_control_vj6p7_xlofq_425",
  "no-image": "awsui_no-image_vj6p7_xlofq_429",
  "image": "awsui_image_vj6p7_xlofq_433"
};
  